export default __webpack_public_path__ + "static/media/xIcon.50acb635.svg";